import Backbone from 'backbone';
import Handlebars from 'handlebars';

import getUserService from '~/services/userService';
import Settings from '~/settings.js';
import EventHub from '~/eventHub';
import template from '~/templates/login.handlebars';
import toastr from 'toastr';

import ProgressService from "~/services/progressService";

var LoginView = Backbone.View.extend({
	className: 'login_wrapper show-signin',
	mfa: false,
	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

	events: {
		'click .submit': 'login',
		'click .to_login': 'showLogin',
		'click .to_register': 'showSignUp',
		'click #open-recoverpassword': 'showRecoverPassword',
		'click #close-recoverpassword': 'show_login',
		'click #recover-password-btn': 'recoverPassword',
		'click #usetoken': 'checkbox'
	},

	render: function() {
		var that = this;
		Parse.Config.get().then((config) => {
			that.mfa = config.get("MFA");
			var handlebarsTemplate = Handlebars.template(template);
			that.$el.html(handlebarsTemplate({
				mfa: that.mfa
			}));
			that.$el.find('.form_login').on('keypress', function(e){
				if(e.key === "Enter") {
					e.preventDefault();
					that.login();
				}
			});
			that.translate();
			EventHub.trigger('renderTickets');
		});
		return this;
	},

	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
			this.$('#email').attr("placeholder", arrlang[lang][this.$('#email').attr("key")]).blur();
			this.$('#email').attr("title", arrlang[lang]["LoginEmailFieldHover"]);
			this.$('#pwd').attr("placeholder", arrlang[lang][this.$('#pwd').attr("key")]).blur();
			this.$('#pwd').attr("title", arrlang[lang]["LoginPasswordFieldHover"]);
			this.$('#user-email').attr("placeholder", arrlang[lang][this.$('#user-email').attr("key")]).blur();
			this.$('#email').attr("title", arrlang[lang]["LoginEmailFieldHover"]);
		}
	},

	showLogin: function() {
		this.$el.removeClass('show-signup').addClass('show-signin');
	},

	showSignUp: function() {
		this.$el.removeClass('show-signin').addClass('show-signup');
	},

	login: function() {
		window.spinnerDialog.show();
		ProgressService.increment();
		var email = this.$('#email').val();
		var pswd = this.$('#pwd').val();
		var token = this.$('#token').val();
		getUserService().authorize(email, pswd, token).then(() => {
			localStorage.setItem('permissions', JSON.stringify({}));
			if(Parse.User.current().attributes.newUser == true){
				var params = {
					id: Parse.User.current().id,
					username: email
				};
				if(Settings.req2fa){
					var params2 = {"userID": Parse.User.current().id };
					Parse.Cloud.run("Unregister2FA", params).then(() => {
						Parse.Cloud.run("Register2FA", params2).then((qr) => {
							QRCode.toDataURL(qr.secret).then(url => {
								params.url = url;
							}).catch(err => {
								console.log(err);
								toastr.error('Error al obtener QR.');
							})
						}).catch((e) => {
							console.log(e);
							toastr.error('Autenticación ya habilitada');
						});
					}).catch((e) => {
						console.log(e);
						Parse.Cloud.run("Register2FA", params2).then((qr) => {
							QRCode.toDataURL(qr.secret).then(url => {
								params.url = url;
							}).catch(err => {
								console.log(err);
								toastr.error('Error al obtener QR.');
							})
						}).catch((e) => {
							console.log(e);
							toastr.error('Autenticación ya habilitada');
						});
					});
				}
				EventHub.trigger('navigate', 'firstlogin', {
					trigger: true
				});
				setTimeout(function() {
					EventHub.trigger('firstLogin:setData', params);
					getUserService().logOut();
				}, 1000);
				window.spinnerDialog.hide();
			}
			else{
				if(Settings.req2fa && !Parse.User.current().attributes.enabled2fa){
					var params = {
						id: Parse.User.current().id
					};
					var params2 = {"userID": Parse.User.current().id };
					Parse.Cloud.run("Unregister2FA", params).then(() => {
						Parse.Cloud.run("Register2FA", params2).then((qr) => {
							QRCode.toDataURL(qr.secret).then(url => {
								params.url = url;
							}).catch(err => {
								console.log(err);
								toastr.error('Error al obtener QR.');
							})
						}).catch((e) => {
							console.log(e);
							toastr.error('Autenticación ya habilitada');
						});
					}).catch((e) => {
						console.log(e);
						Parse.Cloud.run("Register2FA", params2).then((qr) => {
							QRCode.toDataURL(qr.secret).then(url => {
								params.url = url;
							}).catch(err => {
								console.log(err);
								toastr.error('Error al obtener QR.');
							})
						}).catch((e) => {
							console.log(e);
							toastr.error('Autenticación ya habilitada');
						});

					EventHub.trigger('renderChat');
					EventHub.trigger('renderTickets');
					});
					EventHub.trigger('navigate', 'req2fauth', {
						trigger: true
					});
					setTimeout(function() {
						EventHub.trigger('req2fauth:setData', params);
						getUserService().logOut();
					}, 1000);
					window.spinnerDialog.hide();
				}
				else{
					ProgressService.decrement();
					var currentRoute = Backbone.history.getFragment();
					var user = Parse.User.current();
					Parse.Cloud.run("getroles").then((roles) => {
						for (var i = 0; i < roles.length; i++) {
							if (roles[i].attributes.name == user.attributes.role) {
								localStorage.setItem('permissions', JSON.stringify(roles[i].attributes.permissions));
							}
						}
						var n = currentRoute.startsWith("login?url=");
						EventHub.trigger('login');
						if (n) {
							var newroute = currentRoute.substring(10);
							if(newroute == 'firstlogin' || newroute == 'req2fauth'){
								newroute = '';
							}
							EventHub.trigger('navigate', newroute, {
								trigger: true
							});
						}
						else {
							EventHub.trigger('navigate', 'personal', {
								trigger: true
							});
						}
						EventHub.trigger('renderChat');
						EventHub.trigger('renderTickets');
						window.spinnerDialog.hide();
					});
				}
			}
		},
		(error) => {
			console.log(error);
			ProgressService.decrement();
			window.spinnerDialog.hide();
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				case 141:
					if(arrlang[lang][error.message]){
						toastr.error(arrlang[lang][error.message],'Error');
					}
					else{
						var $error = this.$(".login-error").html(arrlang[lang]["LoginError"]);
						setTimeout(function() {
							$error.html('');
						}, 3000);
					}
				break;
				default:
					var $error = this.$(".login-error").html(arrlang[lang]["LoginError"]);
					setTimeout(function() {
						$error.html('');
					}, 3000);
				break;
			}
		});
		return false;
	},

	showRecoverPassword: function(e) {
		$('#recover-password').show();
	},

	show_login: function() {
		this.$el.find("#recover-password").hide();
		this.$el.find("#main-content").show();
	},

	recoverPassword: function(e) {
		this.$('#email').val('');
		this.$('#pwd').val('');
		e.preventDefault();
		var email = this.$el.find('#user-email').val();
		Parse.User.requestPasswordReset(email, {
			success: function() {
				toastr.success(arrlang[lang]['RecoverPasswordOkMsg']);
			},
			error: function(error) {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
					default:
						toastr.error(arrlang[lang]['RecoverPasswordErrorMsg'],'Error');
					break;
				}
			}
		});
	},

	checkbox: function(){
		var value = false;
		if (this.$el.find('#usetoken').is(':checked')){
			value = true;
		}

		if(value){
			this.$el.find('#loginTokenLabel').addClass('hidden');
			this.$el.find('#token').removeClass('hidden');
		} else {
			this.$el.find('#loginTokenLabel').removeClass('hidden');
			this.$el.find('#token').addClass('hidden');
		}
	},
});
/**
 *
 * Module loginView
 * @module views/loginView
 * @returns ParseService
 */
export default LoginView;
